import React from 'react';
import { useRouteError } from 'react-router-dom';

export const ErrorBoundary = () => {
  const error = useRouteError();

  return (
    <div style={{ padding: '24px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      <h1>Ops! Algo deu errado.</h1>
      <p>Desculpe, ocorreu um erro inesperado.</p>
      {error && (
        <pre style={{ background: '#f8f8f8', padding: '16px', borderRadius: '8px', color: '#d9534f' }}>
          {error.message || 'Erro desconhecido.'}
        </pre>
      )}
    </div>
  );
};
